import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { fadeInUp } from '../../lib/animations';

export function HeroSection({ browseArtistsLink, isAdmin, isAuthenticated }) {
  return (
    <section className="relative pt-24 pb-20 overflow-hidden">
      <div className="hero-gradient absolute inset-0 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div {...fadeInUp} transition={{ duration: 0.6 }} className="max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <img src="/logo.png" alt="Tune4Tune" className="h-20 sm:h-24 w-auto" />
            <div className="flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-lime" />
              <span className="text-sm text-lime font-medium uppercase tracking-wider">Custom Dubplates</span>
            </div>
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Get Personal<br />
            <span className="text-lime">Dubplates</span> from<br />
            Top Artists
          </h1>

          <p className="text-lg sm:text-xl text-[#A1A1AA] mb-8 max-w-xl">
            Direct access to Caribbean Dancehall, Reggae and Soca legends.
            Custom voiceovers, personalized drops, exclusive dubplates.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link to={browseArtistsLink} className="btn-primary flex items-center gap-2" data-testid="browse-artists-btn">
              Browse Artists
              <ArrowRight className="w-4 h-4" />
            </Link>
            {!isAdmin && (
              <Link to="/weekly-specials" className="btn-secondary inline-flex items-center gap-2" data-testid="weekly-specials-btn">
                <Sparkles className="w-4 h-4 text-lime" />
                Weekly Specials
              </Link>
            )}
            {!isAuthenticated && (
              <Link to="/register" className="btn-secondary" data-testid="get-started-btn">
                Get Started
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
